export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于我们
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="bg-background-100 rounded-xl border border-background-200/60 p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-1 space-y-5">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  <strong className="text-foreground-900 font-semibold">90影视</strong> 是一个专注高清影视内容聚合的在线观影平台。
                  我们致力于为广大影视爱好者提供最新、最全、最流畅的电影电视剧免费在线观看服务。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  平台涵盖<strong className="text-foreground-900 font-semibold">电影、电视剧、综艺、动漫、纪录片</strong>等多品类内容，
                  每日更新同步播出，全网片源高清画质保障。无论是热门大片还是冷门佳作，在90影视都能找到。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  我们持续优化技术架构与用户体验，支持<strong className="text-foreground-900 font-semibold">网页端、移动端和APP</strong>多设备无缝访问，
                  让每一位用户都能随时随地享受优质的影视娱乐服务。
                </p>
              </div>

              <div className="flex-shrink-0 flex flex-wrap gap-4 md:flex-col md:gap-3 min-w-[160px]">
                <div className="text-center">
                  <div className="text-2xl font-heading font-bold text-primary-500">5年+</div>
                  <div className="text-xs text-foreground-500 mt-0.5">稳定运营</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-heading font-bold text-accent-500">300万+</div>
                  <div className="text-xs text-foreground-500 mt-0.5">月活跃用户</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-heading font-bold text-secondary-500">10万+</div>
                  <div className="text-xs text-foreground-500 mt-0.5">影视资源</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}